import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmationModalComponent implements OnInit {
  showLoadingButton = false;
  showYesLoadingButton = false;
  dropDownFormGroup: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private translateService: TranslateService
  ) { }

  @Input()
  textContentStyle;

  @Input()
  buttonContentStyle;

  @Input()
  modalDialogHeaderContent;

  @Input()
  modalDropDownFields;

  @Input()
  modalDropDownFieldData;

  @Input()
  modalDialogBodyContent = 'bodyContent';

  @Input()
  modalDialogType = 'BLOCK_TOAST';

  @Input()
  modalButtonVal = this.translateService.instant('APP.AppButton_Submit', {Default: 'SUBMIT'});

  @Input()
  modalLinkButtonVal = '';

  @Input()
  thirdBtnShow: boolean;

  @Input()
  modalButtonForThirdBtn = this.translateService.instant('APP.AppButton_No', {Default: 'No'});

  @Input()
  showCancelButton = false;

  @Input()
  showSubmitButton = '';

  @Input()
  showTitle = true;

  @Input()
  showLinkButton = '';

  @Input()
  confirmButtonType = '';

  @Input()
  confirmlayoutAlign = 'left';

  @Input()
  modalYesButtonVal = 'YES';

  @Input()
  modalNoButtonVal = 'NO';

  @Output() linkModalDialogEvent = new EventEmitter<boolean>();

  @Output() cancelModalDialogEvent = new EventEmitter<boolean>();

  @Output() submitModalDialogEvent = new EventEmitter<string>();

  @Output() thirdModalDialogEvent = new EventEmitter<string>();

  @Output() selectionEvent = new EventEmitter<string>();

  @Output() yesModalDialogEvent = new EventEmitter<string>();

  @Output() noModalDialogEvent = new EventEmitter<string>();

  ngOnInit(): void {
    this.showYesLoadingButton = false;
    this.textContentStyle = this.contentStyle(this.textContentStyle);
    this.buttonContentStyle = this.contentStyle(this.buttonContentStyle);
    this.thirdBtnShow = this.thirdBtnShow ? this.thirdBtnShow : false;
    this.modalDialogHeaderContent = this.modalDialogHeaderContent ? this.modalDialogHeaderContent : 'Confirm';
    this.modalDropDownFields = this.modalDropDownFields ? this.modalDropDownFields : 'N';
    this.modalDropDownFieldData = this.modalDropDownFieldData ? this.modalDropDownFieldData : '';
    this.dropDownFormGroup = this.formBuilder.group({
      dropDownVal: ['', Validators.required]
    });
  }

  contentStyle(style) {
    let styleType = '';
    if (style) {
      if (style === 'center') {
        styleType = 'text-center';
      } else if (this.textContentStyle === 'right') {
        styleType = 'text-right';
      } else if (this.textContentStyle === 'left') {
        styleType = 'text-left';
      }
    }
    return styleType;
  }

  raiseModalEvent(eventAction) {
    if(this.confirmButtonType === 'YESNO'){
      if (eventAction === 'yes') {
        this.showYesLoadingButton = true;
        this.yesModalDialogEvent.emit(this.modalYesButtonVal);
      }else if (eventAction === 'no') {
        this.noModalDialogEvent.emit(this.modalNoButtonVal);
      }
    } else {

      if (eventAction === 'cancel') {
        this.cancelModalDialogEvent.emit(true);
      } else if (eventAction === 'submit') {
        this.dropDownFormGroup.markAllAsTouched();
        if (this.modalDropDownFieldData !== '') {
          if (this.dropDownFormGroup.status === 'VALID') {
            this.showLoadingButton = true;
            this.submitModalDialogEvent.emit(this.dropDownFormGroup.value);
            this.selectionEvent.emit(this.dropDownFormGroup.value);
          }
        }
        else {
          this.showLoadingButton = true;
          this.submitModalDialogEvent.emit(this.modalButtonVal);
          this.selectionEvent.emit(this.dropDownFormGroup.value);
        }
      } else if (eventAction === 'No') {
        this.dropDownFormGroup.markAllAsTouched();
        if (this.modalDropDownFieldData !== '') {
          if (this.dropDownFormGroup.status === 'VALID') {
            this.showLoadingButton = true;
            this.thirdModalDialogEvent.emit(this.dropDownFormGroup.value);
            this.selectionEvent.emit(this.dropDownFormGroup.value);
          }
        } else {
          this.showLoadingButton = true;
          this.thirdModalDialogEvent.emit(this.modalButtonForThirdBtn);
          this.selectionEvent.emit(this.dropDownFormGroup.value);
        }
      } else if (eventAction === 'link') {
        this.linkModalDialogEvent.emit(true);
      } else if (eventAction === 'link') {
        this.linkModalDialogEvent.emit(true);
      }
    }
  }

  get dropDownVal() {
      return this.dropDownFormGroup.get('dropDownVal') as FormControl;
    }
  }
